import { render, staticRenderFns } from "./RecordTypeList.vue?vue&type=template&id=7a077036"
import script from "./RecordTypeList.vue?vue&type=script&lang=js"
export * from "./RecordTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports